import React, { useState } from "react";
import axios from "axios";
import AxiosInstance from '../Axios/AxiosInstance';
import * as FaIcons from "react-icons/fa";
export const UploadFiles = () => {
    const [files, setFiles] = useState([]);

    const handleChange = (e) => {
        setFiles(e.target.files);
    };

    const handleUpload = async () => {
        const formData = new FormData();
        for (let file of files) {
            formData.append("files", file);
        }

        try {
            const res = await AxiosInstance.post("/File/upload", formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });

            alert("✅ Upload successful!");
            console.log("Response:", res.data);
        } catch (error) {
            const msg =
                error?.response?.data ||
                error?.message ||
                "Unknown upload error";
            alert("❌ Upload failed: " + msg);
            console.error("Upload error:", error);
        }
    };


    return (
        <div className="container-ul">
            <div className="form-container">
                <h2 className="form-title"><FaIcons.FaRegEdit /> Upload Files(.py, .ino, .hex and .txt)</h2>
               
                <span className="form-message">
                   &nbsp;
                </span>

                <div>
                     <input type="file" multiple accept=".py,.ino" onChange={handleChange} />
                    <button className="submit-button" onClick={handleUpload}>Upload</button>
                </div>
            </div>
        </div> 

      
    );
};

export default UploadFiles;
